import React, { useState } from "react";
import { useIntl } from "react-intl";
import { v4 as uuidv4 } from "uuid";
import { useRefreshAgentToken } from "@/query/agent";
import { useAgentId, useDialog } from "@/hook";
import Button from "@/component/Button";
import { errorToast, successToast } from "@/component/Toast";
import PasteIcon from "@/assets/svgs/paste.svg";
import EyeOpenIcon from "@/assets/svgs/eye.svg";
import EyeCloseIcon from "@/assets/svgs/eye_close.svg";
import RefreshIcon from "@/assets/svgs/refresh_token.svg";


const AgentTokenFrom: React.FC<{value?: string}> = (props) => {
    const { value } = props;

    const intl = useIntl();
    const dialog = useDialog();
    const agentId = useAgentId();
    
    const [showToken, setShowToken] = useState<boolean>(false);

    const { mutateAsync: refreshAgentToken } = useRefreshAgentToken(agentId);

    const onClickTokenCopy = (e: React.MouseEvent) => {
        e.preventDefault();

        navigator.clipboard.writeText(value!).then(() => {
            successToast(intl.formatMessage({ id: "i13031" }));
        });
    };

    const onClickTokenRefresh = (e: React.MouseEvent) => {
        e.preventDefault();
        dialog.open({
            title: intl.formatMessage({ id: "i13032" }),
            content: (
                <div className="flex flex-col gap-1">
                    <div>
                        {intl.formatMessage({ id: "i13033" })}
                    </div>
                    <div className="flex items-start gap-1">
                        {"√"}
                        <div>
                            {intl.formatMessage({ id: "i13034" })}
                        </div>
                    </div>
                </div>
            ),
            variant: "primary",
            onConfirm: async () => {
                await refreshAgentToken({ agent_token: uuidv4() })
                    .then(() => {
                        successToast(intl.formatMessage({ id: "t003" }));
                    })
                    .catch(() => {
                        errorToast(intl.formatMessage({ id: "t004" }));
                    });
            }
        });
    };

    return (
        <div className="flex flex-col gap-1.5">
            <div className="input-group-heading">
                {intl.formatMessage({ id: "i13003" })}
            </div>

            <div className="relative flex gap-3">
                <input readOnly
                       type="text"
                       className="input-default"
                       value={showToken ? value : "••••••••••••••••••••••••••••••••"}
                />

                <Button className="absolute right-[56px] top-[11px]"
                        onClick={() => setShowToken(prev => !prev)}
                >
                    <img src={showToken ? EyeCloseIcon : EyeOpenIcon}
                        alt="view"
                        className="size-4"
                    />
                </Button>

                <div className="flex items-center gap-2">
                    <Button onClick={onClickTokenCopy}>
                        <img src={PasteIcon}
                             alt="paste"
                             className="size-4"
                        />
                    </Button>

                    <Button onClick={onClickTokenRefresh}>
                        <img src={RefreshIcon}
                             alt="refresh"
                             className="size-4"
                        />
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AgentTokenFrom;
